module.exports = __webpack_public_path__ + "static/media/privacy-lock.af27434c.png";